module.exports = __webpack_public_path__ + "img/kjsy_gallery11.47d75b41.jpg";